export default __webpack_public_path__ + "static/color-roles-light-3a8cc52e2a3c321f5322576c4f7fb5a275ae7cbb26d5411b3e1312682b66e8ce.png";